import { createSignal } from 'solid-js';
import type { AlarmExploreMapMarker } from '@utils/alarmsExploreMapMarkers';

const [alarmsExploreMapMarkers, setAlarmsExploreMapMarkers] = createSignal<AlarmExploreMapMarker[]>([]);

export { alarmsExploreMapMarkers, setAlarmsExploreMapMarkers };
